/** Privacy / Terms pages and acceptance gate. */
export const legalUiEn = {
  legalBackHome: 'Back to sign in',
  legalBackApp: 'Back',
  legalUpdated: 'Last updated: {date}',
  legalPrivacyTitle: 'Privacy policy',
  legalTermsTitle: 'Terms of service',
  termsAcceptTitle: 'Accept the terms',
  termsAcceptIntro:
    'Before you continue, please review and accept the Terms of service. They cover how Alea TUI is used for house operations.',
  termsAcceptCheckbox: 'I have read and accept the Terms of service',
  termsAcceptPrivacyLink: 'Privacy policy',
  termsAcceptTermsLink: 'Read the full Terms',
  termsAcceptContinue: 'Accept and continue',
  termsAcceptRequired: 'Confirm the checkbox to continue.',
  legalPrivacyS1Title: 'Who we are',
  legalPrivacyS1Body:
    'Alea TUI helps lottery houses run day-to-day operations (plays, routes, results, and support). This policy explains what data we process when you use the app.',
  legalPrivacyS2Title: 'Data we process',
  legalPrivacyS2Body:
    'We process account data (name, email, role, house assignment), operational records (plays, collections, results), support messages and tickets, device/login trust signals, and basic diagnostics needed to keep the service reliable.',
  legalPrivacyS3Title: 'How we use data',
  legalPrivacyS3Body:
    'Data is used to authenticate users, operate the house workflow, send operational notifications, improve help answers with approved guides, detect integrity issues, and meet security and audit requirements.',
  legalPrivacyS4Title: 'Sharing',
  legalPrivacyS4Body:
    'We do not sell personal data. Data may be processed by infrastructure providers (for example authentication, database, and messaging) under contracts that restrict use to providing the service.',
  legalPrivacyS5Title: 'Retention & rights',
  legalPrivacyS5Body:
    'Operational and audit records are retained as needed for house operations, compliance, and dispute review. Contact your house administrator or platform operator to request access or correction of your account profile.',
  legalPrivacyS6Title: 'Contact',
  legalPrivacyS6Body:
    'For privacy questions, open a support ticket in the app or contact the platform operator who provisioned your account.',
  legalTermsS1Title: 'Agreement',
  legalTermsS1Body:
    'By creating or using an Alea TUI account, you agree to these Terms. If you do not agree, do not use the service. Your house administrator may set additional house rules.',
  legalTermsS2Title: 'Accounts & access',
  legalTermsS2Body:
    'Accounts are provisioned by authorized staff. You must keep credentials secure, use only devices you are allowed to use, and notify an administrator if you suspect unauthorized access.',
  legalTermsS3Title: 'Acceptable use',
  legalTermsS3Body:
    'Use the app only for legitimate house operations. Do not attempt to bypass limits, manipulate results, abuse support channels, or interfere with security, audit, or integrity controls.',
  legalTermsS4Title: 'Operational records',
  legalTermsS4Body:
    'Plays, collections, results, and related logs are authoritative for house operations once recorded according to the product rules. Disputes should be raised promptly through your house process or support tickets.',
  legalTermsS5Title: 'Availability',
  legalTermsS5Body:
    'We aim for reliable service but do not guarantee uninterrupted availability. Maintenance windows or outages may occur. Critical cutoffs and results still follow the times and rules configured for each house.',
  legalTermsS6Title: 'Changes',
  legalTermsS6Body:
    'We may update these Terms. When we do, the app may ask you to accept the new version before continuing. Continued use after acceptance constitutes agreement to the updated Terms.',
} as const;

export const legalUiEs = {
  legalBackHome: 'Volver al acceso',
  legalBackApp: 'Volver',
  legalUpdated: 'Última actualización: {date}',
  legalPrivacyTitle: 'Política de privacidad',
  legalTermsTitle: 'Términos del servicio',
  termsAcceptTitle: 'Aceptar los términos',
  termsAcceptIntro:
    'Antes de continuar, revisa y acepta los Términos del servicio. Describen el uso de Alea TUI en la operación de las casas.',
  termsAcceptCheckbox: 'He leído y acepto los Términos del servicio',
  termsAcceptPrivacyLink: 'Política de privacidad',
  termsAcceptTermsLink: 'Leer los Términos completos',
  termsAcceptContinue: 'Aceptar y continuar',
  termsAcceptRequired: 'Marca la casilla para continuar.',
  legalPrivacyS1Title: 'Quiénes somos',
  legalPrivacyS1Body:
    'Alea TUI ayuda a las casas de lotería a operar el día a día (jugadas, rutas, resultados y soporte). Esta política explica qué datos tratamos al usar la app.',
  legalPrivacyS2Title: 'Datos que tratamos',
  legalPrivacyS2Body:
    'Tratamos datos de cuenta (nombre, correo, rol, casa), registros operativos (jugadas, cobros, resultados), mensajes y tickets de soporte, señales de confianza de dispositivo/inicio de sesión y diagnósticos básicos para mantener el servicio.',
  legalPrivacyS3Title: 'Cómo usamos los datos',
  legalPrivacyS3Body:
    'Los datos se usan para autenticar usuarios, operar el flujo de la casa, enviar notificaciones operativas, mejorar respuestas de ayuda con guías aprobadas, detectar problemas de integridad y cumplir requisitos de seguridad y auditoría.',
  legalPrivacyS4Title: 'Compartición',
  legalPrivacyS4Body:
    'No vendemos datos personales. Pueden procesarlos proveedores de infraestructura (autenticación, base de datos, mensajería) bajo contratos que limitan el uso a prestar el servicio.',
  legalPrivacyS5Title: 'Conservación y derechos',
  legalPrivacyS5Body:
    'Los registros operativos y de auditoría se conservan según haga falta para la operación, cumplimiento y revisión de disputas. Contacta al administrador de tu casa o al operador de la plataforma para solicitar acceso o corrección de tu perfil.',
  legalPrivacyS6Title: 'Contacto',
  legalPrivacyS6Body:
    'Para consultas de privacidad, abre un ticket de soporte en la app o contacta al operador que provisionó tu cuenta.',
  legalTermsS1Title: 'Acuerdo',
  legalTermsS1Body:
    'Al crear o usar una cuenta de Alea TUI aceptas estos Términos. Si no estás de acuerdo, no uses el servicio. El administrador de tu casa puede fijar reglas adicionales.',
  legalTermsS2Title: 'Cuentas y acceso',
  legalTermsS2Body:
    'Las cuentas las provisiona personal autorizado. Debes proteger tus credenciales, usar solo dispositivos permitidos y avisar a un administrador si sospechas acceso no autorizado.',
  legalTermsS3Title: 'Uso aceptable',
  legalTermsS3Body:
    'Usa la app solo para operaciones legítimas de la casa. No intentes evadir límites, manipular resultados, abusar del soporte ni interferir con controles de seguridad, auditoría o integridad.',
  legalTermsS4Title: 'Registros operativos',
  legalTermsS4Body:
    'Jugadas, cobros, resultados y registros relacionados son autoritativos para la operación una vez registrados según las reglas del producto. Las disputas deben plantearse a tiempo por el proceso de la casa o tickets de soporte.',
  legalTermsS5Title: 'Disponibilidad',
  legalTermsS5Body:
    'Buscamos un servicio fiable, pero no garantizamos disponibilidad ininterrumpida. Puede haber mantenimiento o interrupciones. Los cierres y resultados críticos siguen los horarios y reglas configurados en cada casa.',
  legalTermsS6Title: 'Cambios',
  legalTermsS6Body:
    'Podemos actualizar estos Términos. Cuando ocurra, la app puede pedirte aceptar la nueva versión antes de continuar. El uso posterior a la aceptación implica acuerdo con los Términos actualizados.',
} as const;
